import CommissionsService from "./commissions";
import DataService from "./data";
import { Firebase, FirebaseStorage } from "./firebase";
import WebscrapersService from "./webscrapers";

const Api = {
  CommissionsService: new CommissionsService(),
  DataService: DataService,
  WebscrapersService: new WebscrapersService(),
  Firebase: Firebase,
  FirebaseStorage: FirebaseStorage,
};

export default Api;
